
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipYacht as ObiShipYachtElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-yacht.js';
 
 
 

 
 export const ObiShipYacht = createComponent({
   react: React,
   tagName: 'obi-ship-yacht',
   elementClass: ObiShipYachtElement,
   events: {
     
   }
  });
 
 